module.exports = __webpack_public_path__ + "static/media/Hospitality_07.0e9415a8.jpg";